import React, {ReactElement, useContext} from 'react';
import {Typography} from '@customink/pigment-react';
import {useAppSelector} from '../../hooks';
import {useGetStoreDetailsQuery} from '../../api/storesApi';
import DashboardMessage from './DashboardMessage';
import DashboardOrderListing from './DashboardOrderListing';
import DashboardStatus from './DashboardStatus';
import GroupFtuxDialog from '../GroupFtuxDialog';
import NewStoreDialog from '../NewStoreDialog';
import {useStoreType} from '../../hooks/useStoreType';
import {MobileContext} from '../../containers/MobileProvider';
import './index.scss';

type DashboardProps = {
  storeSlug: string;
};

const Dashboard: React.FC<DashboardProps> = ({
  storeSlug
}: DashboardProps): ReactElement => {
  useGetStoreDetailsQuery(storeSlug);
  const storeDetails = useAppSelector(state => state.stores.storeDetails);

  const {isStoreTypeGroupOrder} = useStoreType();
  const mobile = useContext(MobileContext);

  const dashboardContainerClasses = `dashboard-container${
    mobile ? ' mobile' : ''
  }`;
  return storeDetails ? (
    <div className={dashboardContainerClasses}>
      <Typography variant="h5" className="dashboard-header">
        {storeDetails.name} Dashboard
      </Typography>

      {isStoreTypeGroupOrder ? (
        <>
          <DashboardMessage storeSlug={storeSlug} />
          <DashboardStatus storeSlug={storeSlug} />
        </>
      ) : null}
      <DashboardOrderListing storeSlug={storeSlug} />
      <GroupFtuxDialog />
      <NewStoreDialog storeSlug={storeSlug} />
    </div>
  ) : null;
};

export default Dashboard;
